import { render, staticRenderFns } from "./SearchResultsBlock.vue?vue&type=template&id=a4c98146&scoped=true&"
import script from "./SearchResultsBlock.vue?vue&type=script&lang=js&"
export * from "./SearchResultsBlock.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsBlock.vue?vue&type=style&index=0&id=a4c98146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c98146",
  null
  
)

export default component.exports